import React, { useState } from "react";
import MaInput from "../../../Components/UI/ma-input";
import {
  Avatar,
  Box,
  Drawer,
  IconButton,
  InputAdornment,
  List,
  ListItemButton,
  Popover,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { CiSearch } from "react-icons/ci";
import { useDispatch, useSelector } from "react-redux";
import { PiBellSimpleLight } from "react-icons/pi";
import { FaChevronDown } from "react-icons/fa6";
import { FiUser } from "react-icons/fi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { logoutUser } from "../../../store/userSlice";
import ordersIcon from "../../../assets/Icons/seller/package.svg";
import productsIcon from "../../../assets/Icons/seller/delivery-box-01.svg";
import storeIcon from "../../../assets/Icons/shop.svg";
import logo from "../../../assets/Logo/auth-logo.svg";
import { LuMenu } from "react-icons/lu";
import { MdClose } from "react-icons/md";
import { NAV_ITEMS } from "./sidebar";
import { COLORS } from "../../../STYLES/color";
import { HiOutlineChatBubbleLeftRight } from "react-icons/hi2";

const MENU_ITEMS = [
  { label: "My Account", icon: "user", route: "/seller/settings" },
  { label: "Orders", icon: "orders", route: "/seller/orders" },
  { label: "My Products", icon: "products", route: "/seller/my-products" },
  { label: "Back to Mamaket", icon: "store", route: "/" },
];

const MenuIcon = ({ type }) => {
  if (type === "user") {
    return <FiUser className="text-[18px] text-[#333333]" />;
  }
  if (type === "orders") {
    return <img src={ordersIcon} alt="" className="w-[18px] h-[18px]" />;
  }
  if (type === "store") {
    return <img src={storeIcon} alt="" className="w-[18px] h-[18px]" />;
  }
  return <img src={productsIcon} alt="" className="w-[18px] h-[18px]" />;
};

const TopNav = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profile = useSelector((s) => s.user.profile);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleLogout = () => {
    handleClose();
    dispatch(logoutUser());
    navigate("/");
  };

  const storeInitial =
    profile?.store?.storeName?.charAt(0)?.toUpperCase() || "S";

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [openMenu, setOpenMenu] = useState(false);
  const router = useLocation();

  return (
    <div
      className="fixed w-[100%] md:w-[80%] box-border top-0 h-[70px] flex items-center justify-between px-6 bg-[#F8F8F8b7] backdrop-blur-sm z-30"
      style={{ borderBottom: "1px solid #EAEAEA" }}
    >
      {isMobile ? (
        <div className="flex items-center justify-between w-full">
          <Link to={"/seller/dashboard"}>
            <img src={logo} alt="Logo" className="w-[100px]" />
          </Link>
          <IconButton onClick={() => setOpenMenu(!openMenu)}>
            <LuMenu />
          </IconButton>
        </div>
      ) : (
        <div className="w-full box-border flex justify-between items-center">
          <div className="w-[25%]">
            <MaInput
              placeholder="Search products…"
              fullWidth
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position="end">
                      <CiSearch className="text-[25px]" />
                    </InputAdornment>
                  ),
                },
              }}
            />
          </div>

          <div className="flex items-center gap-x-4">
            
            <Tooltip title="Chat with Buyer">
              <Link to="/chat">
              <IconButton>
              <HiOutlineChatBubbleLeftRight />
              </IconButton>
              </Link>
            </Tooltip>
            <IconButton>
              <PiBellSimpleLight className="text-black" />
            </IconButton>

            <div
              role="button"
              tabIndex={0}
              aria-haspopup="true"
              aria-expanded={open}
              onClick={handleOpen}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") handleOpen(e);
              }}
              className="flex items-center gap-x-3 cursor-pointer select-none"
            >
              <Avatar
                src={profile?.store?.storeLogo || undefined}
                sx={{
                  width: 40,
                  height: 40,
                  bgcolor: "#2E1834",
                  fontSize: "1rem",
                  fontWeight: 600,
                }}
              >
                {!profile?.store?.storeLogo && storeInitial}
              </Avatar>
              <div className="w-[100px] min-w-0">
                <h1 className="my-0 text-[16px] font-semibold text-[#151515] truncate">
                  {profile?.store?.storeName || "Store Name"}
                </h1>
                <p className="my-0 text-[12px] text-[#626262] truncate">
                  {profile?.email}
                </p>
              </div>
              <FaChevronDown
                className={`text-[#333333] text-[12px] transition-transform duration-200 ${
                  open ? "rotate-180" : ""
                }`}
              />
            </div>

            <Popover
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              slotProps={{
                paper: {
                  sx: {
                    mt: 1.5,
                    borderRadius: "12px",
                    border: "1px solid #EFEFEF",
                    boxShadow: "0 8px 24px rgba(15, 23, 42, 0.1)",
                    overflow: "visible",
                    minWidth: 200,
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: -6,
                      right: 28,
                      width: 12,
                      height: 12,
                      bgcolor: "#fff",
                      borderLeft: "1px solid #EFEFEF",
                      borderTop: "1px solid #EFEFEF",
                      transform: "rotate(45deg)",
                    },
                  },
                },
              }}
            >
              <Box sx={{ py: 0.5, overflow: "hidden", borderRadius: "12px" }}>
                {MENU_ITEMS.map((item, idx) => (
                  <Link
                    key={item.label}
                    to={item.route}
                    onClick={handleClose}
                    className="no-underline"
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        px: 2,
                        py: 1.5,
                        color: "#333333",
                        fontSize: "14px",
                        fontWeight: 500,
                        borderBottom:
                          idx < MENU_ITEMS.length - 1
                            ? "1px solid #F0F0F0"
                            : "none",
                        "&:hover": { bgcolor: "#FAFAFA" },
                      }}
                    >
                      <MenuIcon type={item.icon} />
                      {item.label}
                    </Box>
                  </Link>
                ))}
                <Box
                  onClick={handleLogout}
                  sx={{
                    px: 2,
                    py: 1.75,
                    textAlign: "center",
                    cursor: "pointer",
                    borderTop: "1px solid #F0F0F0",
                    color: "#E85D75",
                    fontSize: "14px",
                    fontWeight: 600,
                    "&:hover": { bgcolor: "#FFF5F6" },
                  }}
                >
                  Log out
                </Box>
              </Box>
            </Popover>
          </div>
        </div>
      )}

      <Drawer anchor="left" open={openMenu} onClose={() => setOpenMenu(false)}>
        <div className="w-[85dvw] h-[100dvh] flex flex-col py-5 justify-between box-border">
        <div>
        <div
            className="flex items-center justify-between px-5 pb-2 "
            style={{ borderBottom: "1px solid #001A2B1A" }}
          >
            <Link to={"/seller/dashboard"}>
              <img src={logo} alt="Logo" className="w-[100px]" />
            </Link>
            <IconButton onClick={() => setOpenMenu(false)}>
              <MdClose className="text-[#FF465C]" />
            </IconButton>
          </div>
          {/* MENUS  */}
          <div>
          <div className="mt-5 px-5">
        <List>
          {NAV_ITEMS.map((nav, id) => (
            <Link to={nav.route} key={id}>
              <ListItemButton
              onClick={() => setOpenMenu(false)}
                selected={
                  id === 0
                    ? router.pathname === nav.route
                    : router.pathname.includes(nav.route)
                }
                sx={{
                  height: 40,
                  my: 2,
                  color: "#1515151",
                  " 	&.Mui-selected": {
                    borderRadius: "12px",
                    bgcolor: COLORS.PRIMARY_DARK,
                    borderLeft: "4px solid #2E1834",
                    fontWeight: 600,

                    "& > span ": {
                      color: "#fff",
                    },
                  },
                }}
              >
                <img src={nav.icon} alt={nav.name} className="mr-3" />

                <span className="text-[#666666] text-[14px] line-clamp-1">
                  {nav.name}
                </span>
              </ListItemButton>
            </Link>
          ))}
        </List>
      </div>
          </div>
        </div>


        {/* FOOTER */}
        <div className="px-5 pt-3" style={{ borderTop: "1px solid #001A2B1A" }}>
        <div
             
              className="flex items-center gap-x-3 cursor-pointer select-none"
            >
              <Avatar
                src={profile?.store?.storeLogo || undefined}
                sx={{
                  width: 40,
                  height: 40,
                  bgcolor: "#2E1834",
                  fontSize: "1rem",
                  fontWeight: 600,
                }}
              >
                {!profile?.store?.storeLogo && storeInitial}
              </Avatar>
              <div className=" min-w-0">
                <h1 className="my-0 text-[14px] font-semibold text-[#151515] truncate">
                  {profile?.store?.storeName || "Store Name"}
                </h1>
                <p className="my-0 text-[12px] text-[#626262] truncate">
                  {profile?.email}
                </p>
              </div>
            
            </div>
        </div>
        </div>
      </Drawer>
    </div>
  );
};

export default TopNav;
